/**
 * Google Tag Manager (GTM) Event Tracking Helper - V2
 * 
 * Standardisiertes Event-System für SEA Tracking (Meta Ads, Google Ads)
 * Event-Name: Immer "UserInteraction"
 * Variablen: FormAction, FormName, StepNumber, StepName, etc.
 */

/**
 * Pusht ein standardisiertes Event in den GTM dataLayer
 * @param {string} formAction - Aktion: Started, Step, LastStepReached, Success, Error
 * @param {string} formName - Formular-Name: Valuation, SearchProfile, Contact, NewsletterOptin, PropertyExpose
 * @param {object} additionalData - Zusätzliche Daten (StepNumber, StepName, objektart, etc.)
 */
export const pushGTMEvent = (formAction, formName, additionalData = {}) => {
  try {
    // Initialisiere dataLayer falls nicht vorhanden
    window.dataLayer = window.dataLayer || [];
    
    // Push Event mit standardisierter Struktur
    window.dataLayer.push({
      'event': 'UserInteraction',
      'FormAction': formAction,
      'FormName': formName,
      ...additionalData
    });
    
    console.log(`[GTM] UserInteraction - ${formAction} - ${formName}`, additionalData);
  } catch (error) {
    console.error('[GTM] Error pushing event:', error);
  }
};

/**
 * FormAction Werte (standardisiert)
 */
export const FormActions = {
  STARTED: 'Started',                    // Erste Interaktion mit Formular
  STEP: 'Step',                          // Schritt abgeschlossen
  LAST_STEP_REACHED: 'LastStepReached', // Letzter Schritt erreicht
  SUCCESS: 'Success',                    // Erfolgreich versendet
  ERROR: 'Error'                         // Fehler beim Submit
};

/**
 * FormName Werte (englisch, standardisiert)
 */
export const FormNames = {
  VALUATION: 'Valuation',              // Bewertungsformular (Lead Form)
  SEARCH_PROFILE: 'SearchProfile',     // Suchprofil (Käufer-Registrierung)
  CONTACT: 'Contact',                  // Maklerauftrag/Kontakt
  NEWSLETTER_OPTIN: 'NewsletterOptin', // Newsletter-Anmeldung
  PROPERTY_EXPOSE: 'PropertyExpose',   // Käufer-Radar (Matching-Tool)
  ESTATE_PLANNER: 'EstatePlanner',     // Nachlass-Planer
  QUICK_SEARCH: 'QuickSearch',         // Quick-Search Hero-Form (oben)
  BUYER_CONTACT: 'BuyerContact'        // Käufer-Interesse Kontaktformular (NEU!)
};

/**
 * Schritt-Namen für Bewertungsformular
 */
export const ValuationSteps = {
  1: 'Location',        // Standort
  2: 'PropertyDetails', // Flächendetails
  3: 'Usage',          // Verwendungszweck
  4: 'ContactInfo'     // Kontaktdaten
};

/**
 * Helper: Formular-Start tracken (nur bei User-Interaktion!)
 * Soll NICHT in useEffect aufgerufen werden, sondern bei onFocus/onClick
 */
export const trackFormStarted = (formName) => {
  pushGTMEvent(FormActions.STARTED, formName);
};

/**
 * Helper: Formular-Schritt abgeschlossen
 */
export const trackFormStep = (formName, stepNumber, stepName, totalSteps) => {
  pushGTMEvent(FormActions.STEP, formName, {
    StepNumber: stepNumber,
    StepName: stepName,
    TotalSteps: totalSteps
  });
};

/**
 * Helper: Letzter Schritt erreicht
 */
export const trackLastStepReached = (formName, stepNumber, stepName) => {
  pushGTMEvent(FormActions.LAST_STEP_REACHED, formName, {
    StepNumber: stepNumber,
    StepName: stepName
  });
};

/**
 * Helper: Formular erfolgreich versendet
 */
export const trackFormSuccess = (formName, additionalData = {}) => {
  pushGTMEvent(FormActions.SUCCESS, formName, additionalData);
};

/**
 * Helper: Formular-Fehler
 */
export const trackFormError = (formName, errorMessage) => {
  pushGTMEvent(FormActions.ERROR, formName, {
    error_message: errorMessage
  });
};

export default {
  pushGTMEvent,
  FormActions,
  FormNames,
  ValuationSteps,
  trackFormStarted,
  trackFormStep,
  trackLastStepReached,
  trackFormSuccess,
  trackFormError
};

